// *nutrition education
export const POST_NUTRITION_EDUCATION_REQUEST = 'POST_NUTRITION_EDUCATION_REQUEST';
export const POST_NUTRITION_EDUCATION_SUCCESS = 'POST_NUTRITION_EDUCATION_SUCCESS';
export const POST_NUTRITION_EDUCATION_FAILED = 'POST_NUTRITION_EDUCATION_FAILED';
export const FILTER_NUTRITION_EDUCATION_REQUEST = 'FILTER_NUTRITION_EDUCATION_REQUEST';
export const FILTER_NUTRITION_EDUCATION_SUCCESS = 'FILTER_NUTRITION_EDUCATION_SUCCESS';
export const FILTER_NUTRITION_EDUCATION_FAILED = 'FILTER_NUTRITION_EDUCATION_FAILED';
